const DEFAULT_ERROR_MESSAGE = 'Возникла ошибка, отправьте запрос заново';

const ERROR_MESSAGE_MAP = {
    406: 'Увы, с таким запросом я не могу помочь',
};

export const getLLMErrorMessage = (statusCode: number): string => ERROR_MESSAGE_MAP?.[statusCode] || DEFAULT_ERROR_MESSAGE;
